import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, useMultiStyleConfig} from '@chakra-ui/react'
import {reinitFeefo} from '../../custom-api/hooks/use-feefo'
import {Global, css} from '@emotion/react'

const ReviewsOnPage = ({parentSku}) => {
    const stylesGlobal = useMultiStyleConfig('ReviewsOnPage')
    const normalizedParentSku = parentSku?.toUpperCase().replace(/[^A-Z0-9_: ]/g, '')

    useEffect(() => {
        reinitFeefo()
    }, [parentSku])

    return (
        <Flex
            {...stylesGlobal.outerContainer}
            id="reviewsOnPage"
            layerStyle="page"
            sx={{
                // Feefo leaves the widget div empty when there's nothing to show;
                // collapse the padded container in that case instead of reserving blank space.
                '&:has(#feefo-product-review-widgetId:empty)': {
                    display: 'none',
                },
            }}
        >
            <Box {...stylesGlobal.container}>
                <Global
                    styles={css`
                        ${stylesGlobal.global}
                    `}
                />

                {normalizedParentSku && (
                    <>
                        <div
                            id="feefo-product-review-widgetId"
                            className="feefo-review-widget-product"
                            data-parent-product-sku={normalizedParentSku}
                        ></div>
                    </>
                )}
            </Box>
        </Flex>
    )
}

ReviewsOnPage.propTypes = {
    parentSku: PropTypes.string.isRequired,
}

export default ReviewsOnPage
